(function ($) {
  'use strict';
  let popup = "<div class='popupwindow'><i class='far fa-times close'></i><div class='content'></div></div>";
  $(document).ready(function () {
    if ($(window).innerWidth() >= 1024) {
      $(".view-id-factory > .map_filter").append($(popup));
      $(".view-id-factory > .map_filter .pin circle").on("click", (e) => {
        let id = $(e.currentTarget).parent().attr('id');
        let target = '#al' + id.substr(1);
        let element = $(target).length > 0 ? $(target)[0] : null;
        let offsetX = e.offsetX;
        let offsetY = e.offsetY;

        if (element != null) {
          let offset = $(".view-id-factory > .map_filter").offset();
          offsetX = e.pageX - offset.left - 125;
          offsetY = e.pageY - offset.top - 120;
          $(".popupwindow").css({
            top: offsetY,
            left: offsetX,
          });
          if ($(".popupwindow .content").children().length > 0) {
            if (target !== "#" + $($(".popupwindow .content > .popup")[0]).attr("id")) {
              $(".popupwindow .content").empty();
              $(element).clone().appendTo(".popupwindow .content");
            } else {
              if ($(".popupwindow").is(":visible")) {
                $(".popupwindow").slideUp();
              } else {
                $(".popupwindow").slideDown();
              }
            }
          } else {
            $(element).clone().appendTo(".popupwindow .content");
            $(".popupwindow").slideDown();
          }
        } else {
          $(".popupwindow .content").empty();
          $(".popupwindow").slideUp();
        }
      });

      $(".popupwindow").on("click", (e) => {
        $(".popupwindow .content").empty();
        $(".popupwindow").slideUp();
      });
    }
  });


})(jQuery);
